type UserNameParts = {
  readonly email?: string | null;
  readonly firstName?: string | null;
  readonly lastName?: string | null;
};

/** The first code point, so a character outside the BMP is not split in half. */
function getFirstCharacter(value: string | null | undefined) {
  return Array.from(value?.trim() ?? '')[0] ?? '';
}

/**
 * One to two uppercase initials: the first letters of the first and last
 * name, else the first letter of the e-mail address, else `?`.
 */
export function getInitials({ email, firstName, lastName }: UserNameParts) {
  const nameInitials =
    getFirstCharacter(firstName) + getFirstCharacter(lastName);
  const initials = nameInitials || getFirstCharacter(email);

  return initials ? initials.toUpperCase() : '?';
}

/**
 * The user's full name, or the e-mail address when no name part is stored.
 */
export function getUserDisplayName({
  email,
  firstName,
  lastName,
}: UserNameParts & { readonly email: string }) {
  return [firstName, lastName].filter(Boolean).join(' ') || email;
}
